<template>
  <div class="fixed w-full bg-white navContainer animated" :class="{ 'scrolled': !view.atTopOfPage }">
    <nav class="max-w-6xl m-auto flex items-center justify-between flex-wrap bg-white p-6">
  <div class="flex items-center flex-shrink-0 text-white mr-6">
    <router-link class="navbar-item" to="/">
      <img src="@/assets/logo.png" alt="Logo" width="30">
    </router-link>
  </div>
  <div class="block md:hidden">
    <button @click="toggleMobMenu" class="flex items-center px-3 py-2 rounded text-gray-800 cursor-pointer">
      <svg class="fill-current h-5 w-5" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
    </button>
  </div>
  <div class="w-full md:w-auto flex-end lg:flex lg:items-center lg:w-auto lg:h-auto">
    <div class="bg-white md:shadow-none rounded flex flex-col md:flex-row menu fixed md:relative w-3/4 md:w-auto r-2 shadow-2xl pl-5 md:p-0 py-3" :class="{'unShown': !view.showNav}">
      <router-link class="mr-5 text-center md:font-thin rounded text-gray-600 hover:text-gray-700 py-3 px-3" to="/pricing">
        Pricing
      </router-link>
      <router-link class="mr-5 text-center md:font-thin rounded text-gray-600 hover:text-gray-700 py-3 px-3" to="/account" v-if="user">
        My Account
      </router-link>
      <button class="mr-5 md:font-thin rounded text-white py-3 px-3 bg-green-500 shadow-md" v-on:click="view.signUpModal.show=true" v-if="!user">
        Sign Up!
      </button>
      <button class="mr-5 md:font-thin rounded text-gray-600 py-3 px-3" v-on:click="view.signInModal.show=true" v-if="!user">
        Sign In
      </button>
      <button class="mr-5 md:font-thin rounded text-gray-600 py-3 px-3" v-on:click="logout" v-if="user">
        Log Out
      </button>
    </div>
  </div>
</nav>
        
    <div class="modal fixed w-full h-full " id="signInModal" v-if="view.signInModal.show" >
      <div class="modal-background" @click="view.signInModal.show=false">
      </div>
        <div class="modal-content w-full">
            <p class="text-xl is-grey text-center">Sign In</p>
            <form @submit="signInUser" id="signInForm" action="#">
                <div class="mb-3">
                  <input name="email" class="input text-center w-full py-1 rounded" type="text" placeholder="email" autocomplete="email" v-model="userEmail" required>
                </div>
                <div class="mb-3">
                  <input name="password" class="input text-center w-full py-1 rounded" type="password" autocomplete="new-password" placeholder="password" value="" v-model="userPassword" required minlength="1">
                  <a class="w-full block text-xs text-gray-600 mt-3 text-center" @click="view.resetPasswordModal.show = true; view.signInModal.show = false">Forgot Password?</a>
                </div>
                <div class="w-full text-center">
                  <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" :class="{'disabled': view.signInModal.isLoading}">Sign In</button>
                  <p v-if="view.signInModal.error" class="text-red-700 block text-sm mt-2 text-center">{{view.signInModal.error}}</p>
                </div>
            </form>
        </div>
        <button class="modal-close is-large" aria-label="close" v-on:click="view.signInModal.show=false"></button>
    </div>

    <div class="modal fixed w-full h-full " id="resetPWModal" v-if="view.resetPasswordModal.show">
      <div class="modal-background" @click="view.resetPasswordModal.show=false">
      </div>
      <div class="modal-content w-full">
          <div v-if="!view.resetPasswordModal.successMessage">
            <p class="text-xl is-grey text-center">Reset Password</p>
            <form @submit="resetPassword" id="resetPWForm" action="#">
                <div class="mb-3">
                  <input name="email" class="input text-center w-full py-1 rounded" type="text" placeholder="email" autocomplete="email" v-model="userEmail" required>
                </div>
                <div class="control text-center">
                    <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" :class="{'disabled': view.resetPasswordModal.isLoading}">Reset</button>
                </div>
                <p v-if="view.resetPasswordModal.error" class="text-red-700 block text-sm mt-2 text-center">{{view.resetPasswordModal.error}}</p>
            </form>
          </div>
          <div v-else class="text-center">
            <p class="text-xl is-grey">Done<br>Check your email for instructions on how to reset your password. :)</p>
            <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" @click="view.resetPasswordModal.show = false" style="margin-top:20px">Got it!</button>
          </div>
      </div>
    </div>

    <div class="modal fixed w-full h-full" id="signupModal" v-if="view.signUpModal.show">
        <div class="modal-background" @click="view.signUpModal.show=false"></div>
        <div class="modal-content">
            <p class="text-xl is-grey text-center">Sign Up</p>
            <form @submit="signUpUser" id="signupForm" action="#">
                <div class="mb-3">
                  <input name="email" class="input text-center w-full py-1 rounded" type="text" placeholder="email" autocomplete="email" required v-model="userEmail">
                </div>
                <div class="mb-3">
                  <input name="password" class="input text-center w-full py-1 rounded" type="password" autocomplete="new-password" placeholder="password" value="" required minlength="8" v-model="userPassword">
                    <p class="text-gray-500 block text-sm mt-2 text-center">min 8 characters</p>
                </div>
                <div class="">
                    <div class="control" style="display: flex;align-items: center;">
                        <span class="is-size-6">livedata.ninja/dash/</span>
                        <input name="url" class="input py-1 rounded" type="text" placeholder="your unique URL" value="" required v-model="userDashboardName" v-on:input="checkDashUrl" style="padding-left: 4px;">
                    </div>
                    <p v-if="view.dashCheck.show && view.dashCheck.isLoading && userDashboardName.length > 0" class="text-gray-700 block text-sm mt-2 text-center">Checking URL</p>
                    <div v-if="!view.dashCheck.isLoading">
                      <p v-if="this.userDashboardName.length < 4 && this.userDashboardName.length > 0" class="text-gray-700 block text-sm mt-2 text-center">Must be at least 4 characters</p>
                      <p v-if="view.dashCheck.show && view.dashCheck.isAvailable" class="text-center text-sm text-green-600 mt-2">URL is available!</p>
                      <p v-if="view.dashCheck.show && !view.dashCheck.isLoading && !view.dashCheck.isAvailable" class="text-center text-red-500 mt-2 text-sm">URL is taken :(</p>
                    </div>
                </div>
                <div class="mt-5 text-center">
                  <button class="rounded text-white py-2 px-3 bg-green-500 shadow-md" :class="{'disabled': view.signUpModal.isLoading}">Sign up and reserve</button>
                  <p v-if="view.signUpModal.error" class="text-center text-red-500 mt-2 text-sm">{{view.signUpModal.error}}</p>
                </div>
            </form>
        </div>
    </div>

  </div>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'HeaderNav',
  props: {
    msg: String
  },
  data: function () {
    return {
      view: {
        atTopOfPage: true,
        showNav: false,
        dashCheck: {
          isAvailable: false,
          isLoading: false,
          show: false
        },
        signInModal: {
          show: false,
          error: null,
          isLoading: false
        },
        signUpModal: {
          show: false,
          error: null,
          isLoading: false
        },
        resetPasswordModal: {
          show: false,
          error: null,
          isLoading: false,
          successMessage: false
        }
      },
      userEmail: "",
      userPassword: "",
      userDashboardName: "",
      currentController: null
    }
  },
  // a beforeMount call to add a listener to the window
  beforeMount () {
      window.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    authChecked () {
      return this.$store.getters.authChecked
    }
  },
  watch:{
      $route (){
        this.view.showNav = false
      }
  }, 
  mounted: function() {


  },
  methods: {
    handleScroll(){
        // when the user scrolls, check the pageYOffset
        if(window.pageYOffset>0){
            // user is scrolled
            if(this.view.atTopOfPage) this.view.atTopOfPage = false
        }else{
            // user is at top of page
            if(!this.view.atTopOfPage) this.view.atTopOfPage = true
        }
    },
    toggleMobMenu(){
      console.log("user wants to toggle menu");
      this.view.showNav = !this.view.showNav;
    },
    subscribeUser(email){
      let obj = {
        "email": email
       }
      fetch('/api/subscribe/mailchimp', {
          method: 'post',
          body: JSON.stringify(obj),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response=>{
          return response.json();
        })
        .then(data=>{
          // console.log("user subscribed data:", data)
          if(data.error){
            throw data.error
          } else {
            // user subscribed successfully
          }
        })
        .catch(()=>{
          // console.log("err subscribing user:", err);
        })
    },
    resetPassword(e){
      e.preventDefault();
      console.log('user is resetting password:', this.userEmail);

      this.view.resetPasswordModal.isLoading = true;
      this.view.resetPasswordModal.error = null;

      let actionCodeSettings = {
        url: 'https://livedata.ninja/',
      };

      firebase.auth().sendPasswordResetEmail(this.userEmail, actionCodeSettings)
        .then(data => {
          console.log("reset data:", data)
          this.view.resetPasswordModal.successMessage = true;
        // Email sent.
      }).catch(error => {
        // An error happened.
        console.log("error reset pw:", error)
        this.view.resetPasswordModal.error = error;
      })
      .finally(()=>{
        this.view.resetPasswordModal.isLoading = false;
      })
    },
    logout() {
      this.$store
        .dispatch('signOut')
        .then( () => {
          console.log("logOUT success, user:", this.user);
          this.$router.replace("/")
        }) 
        .catch( err => {
          console.log("err signing user out:", err.message)
        })
        .finally( () => {
          this.view.showNav = false
        })
    },
    signInUser(e){

      e.preventDefault();
      
      // clear any error messages
      this.view.signInModal.error = null

      // show loading
      this.view.signInModal.isLoading = true

      // console.log('user wants to sign in:', this.userEmail);
      this.$store
        .dispatch('signIn',{"email":this.userEmail, "password":this.userPassword})
        .then(response=>{
          console.log("dispatch login response:", response);
          console.log("login success, user:", this.user);
          this.view.signInModal.show = false;
          this.userEmail = "";
          this.userPassword = "";

          // send user to /account
          this.$router.replace('/account')
          
        }) 
        .catch(err=>{
          this.view.signInModal.error = err.message
        })
        .finally(()=>{
          this.view.signInModal.isLoading = false;
          this.view.showNav = false
        })
    },
      signUpUser(e){

      e.preventDefault();

      this.view.signUpModal.isLoading = true

      // subscribe user
      this.subscribeUser(this.userEmail);

      let newUser = {
        "email": this.userEmail,
        "password": this.userPassword,
        "dashboardName": this.userDashboardName
      }

      // console.log("newUser wants to sign up:", newUser);
      // if they haven't selected an available URL
      // Don't let them submit the form
      // show them an error
      if(!this.view.dashCheck.isAvailable || this.view.dashCheck.isLoading){
        this.view.signUpModal.error = "Select an available URL for your dashboard"
        return
      }

      this.$store
        .dispatch('signUp',newUser)
        .then(response=>{
          console.log('user created:', response);
          this.view.signUpModal.show = false;
          this.userEmail = "";
          this.userPassword = "";
          this.userDashboardName = "";
          this.$router.replace(`/account`)
        }) 
        .catch(err=>{
          this.view.signUpModal.error = err.message
        })
        .finally(()=>{
          this.view.signUpModal.isLoading = false
        })

    },
    async checkDashUrl(){

      let name = encodeURI(this.userDashboardName.toLowerCase())

      // cancel if no name, or name too short (user emptied input)
      if(name.length < 4){
        return this.view.dashCheck.show = false
      }
      // when the user enters a dashboard name
      // check to see if it's available
      // show input text, show it's loading
      this.view.dashCheck.isLoading = true;
      this.view.dashCheck.show = true;

      // abort previous one if it exists
      if(this.currentController){
        // console.log("cancelling request");
        this.currentController.abort()
      }

      this.currentController = new AbortController()
      let signal = this.currentController.signal

      try {
        let response = await fetch(`/api/check/dashboard?name=${name}`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            signal: signal
          })
  
        let responseData = await response.json()
        // console.log('responseData:', responseData);
        
        if(responseData.data.availability){
          this.view.dashCheck.isAvailable = true
        } else {
          this.view.dashCheck.isAvailable = false
        }
  
        // show message, disable loading
        this.view.dashCheck.isLoading = false
        this.view.dashCheck.show = true

      } catch (err) {
        if(err=="AbortError: The user aborted a request."){
          console.log('request aborted')
        } else {
          console.log("error checking dashname: "+err);
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .navContainer {
      z-index: 20
  }

  .navContainer.scrolled {
      @apply shadow-2xl;
      border-bottom: 0px;
  }

  @media only screen and (max-width: 767px) {
    .menu {
      right:10px;
      transition: all 0.2s ease;
      z-index:10;
    }
    .menu.unShown {
      right:-100%;
    }
  }
</style>
